/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Orders_TotalInputs */

const vi_report_orders_total = /** @type {(inputs: Report_Orders_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng đơn`)
};

/**

* @param {Report_Orders_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_orders_total = /** @type {((inputs?: Report_Orders_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Orders_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_orders_total(inputs)
});